<div class="fw-bold bg-white p-3 rounded-5 m-3 shadow">
  <div class="row justify-content-center">
    <div class="col-sm-11">
      <div class="d-flex justify-content-between mb-3">
        <label for="information" class="labelInformation">Revert Device Transfers</label>

        <div class="col btn-back text-end">
          <a class="btn btn-secondary" [routerLink]="['/inventory']"><i class="bi bi-arrow-left-circle"></i> Back</a>
        </div>


      </div>


      <!-- Stepper Progress -->
      <div class="stepper">
        <div class="stepper-progress">
          <div class="stepper-progress-bar" [style.width.%]="progressPercentage"></div>
          <div *ngFor="let step of steps; let i = index" class="stepper-step" [class.active]="currentStep === i"
               [class.completed]="currentStep > i">
            <span>{{ i + 1 }}</span>
            <span class="stepper-step-label">{{ step.label }}</span>
          </div>
        </div>


        <!-- Step 1: Personal Info -->
        <div class="step" [class.active]="currentStep === 0">

          <div>
            <ul class="nav nav-tabs mb-3" id="transferTypeTab" role="tablist">
              <!--
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="direct-transfer-tab" data-bs-toggle="tab" data-bs-target="#direct-transfer" type="button" role="tab" aria-selected="true">
                  Direct Assignment
                </button>
              </li>
              -->
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="plan-transfer-tab" data-bs-toggle="tab" data-bs-target="#plan-transfer" type="button" role="tab" aria-selected="false" tabindex="-1">
                  Plan Assignment
                </button>
              </li>
            </ul>

            <div class="tab-content" id="transferTypeTabContent">
              <!--
              <div class="tab-pane fade show active" id="direct-transfer" role="tabpanel" aria-labelledby="#direct-transfer-tab">
                $1$ <p>You are about to transfer <strong><span id="selected-count">1</span> device(s)</strong> directly to
                    a
                    customer.</p> #1#
                <div class="mb-3">
                  <label for="customer-select" class="form-label">Select a Customer</label>
                  <app-dropdown-control [items]="customersDropdownList" [selectedKey]="selectedCustomer" (selectionChange)="onCustomerChange($event)"></app-dropdown-control>
                </div>
              </div>
              -->

              <div class="tab-pane fade show active" id="plan-transfer" role="tabpanel" aria-labelledby="#plan-transfer-tab">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="plan-customer-select" class="form-label">Select a Customer Plan</label>
                    <app-dropdown-control [items]="userPlansList" [selectedKey]="selectedUserPlan" (selectionChange)="onUserPlanChange($event)"></app-dropdown-control>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Step 2: Contact Info -->
        <div class="step" [class.active]="currentStep === 1">
          <p *ngIf="selectedDevices.length > 0" class="mb-4">
            you have selected <span class="badge"
                                    style="background-color: #7ab956;">{{selectedDevices.length}}</span> device(s) to revert the transfer
          </p>
          <p *ngIf="selectedDevices.length === 0" class="mb-4">please select device(s) to revert the transfer</p>
          <div>
            <app-table-control [data]="devices" [columns]="columns" [showCheckboxes]="true"
                               (selectedItemsChange)="onSelectionChange($event)" [pageSize]="5" [clearSelection]="clearSelection">
            </app-table-control>
          </div>
        </div>



        <!-- Step 4: Review -->
        <div class="step" [class.active]="currentStep === 2">
          <h2 class="mb-4">Review Your Information</h2>
          <div>
            <p>
              You are about to roll back the transfer of <span class="badge"
                                                               style="background-color: #7ab956;">
                <span>{{selectedDevices.length}}</span>
                device(s)
              </span> {{reviewInfoMessage}}.
            </p>
          </div>
          <div>
            <p><strong>Detail of selected devices:</strong></p>
            <ul>
              <li *ngFor="let device of selectedDevices">
                <strong>{{device.iccid}}</strong>
              </li>
            </ul>
          </div>
        </div>

        <!-- Navigation Buttons -->
        <div class="navigation-buttons">
          <button type="button" class="btn btn-secondary" (click)="previousStep()" [disabled]="currentStep === 0">
            Previous
          </button>
          <button type="button" class="btn btn-primary" (click)="nextStep()" *ngIf="currentStep < steps.length - 1"
                  [disabled]="!isCurrentStepValid()">
            Next
          </button>
          <button type="button" class="btn btn-primary" (click)="transferDevices()"
                  *ngIf="currentStep === steps.length - 1">
            Finish
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
